import {MutationTree} from "vuex";
import IDPVariableSettings from "@/modules/DynamicProfiling/ts/IDPVariableSettings";

export const mutations: MutationTree<any> = {

    setDataVariableUsageStats(state: any, payload: any) {
        state.dpVariables = payload.dynamic_profiling_variables;
        state.projectMaxUsage = payload.project_max_usage;
        state.projectCount = payload.project_count;
        state.panelistCount = payload.panelist_count;
    },

    setDynamicProfilingStats(state: any, payload: any) {
        state.dynamicProfilingStats = payload;
    },

    updateDPVariableSettings(state: any, payload: IDPVariableSettings) {

        const index = state.dpVariables
            .findIndex((v: IDPVariableSettings) => v.data_variable_id === payload.data_variable_id);

        if (index !== -1) {
            const merged = Object.assign({}, state.dpVariables[index], payload);
            state.dpVariables.splice(index, 1, merged);
        }
    }
};
